// Add your custom JS here.

(function($) {

  //to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '30px'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      });

      topBtn.on('click', function(){
        $('body,html').animate({
          scrollTop: 0},500);
          return false;
      });
        
  });

  
  // page-link-scroll
  $(function() {
    let headerHeight = 0;
    //headerHeight = $('#main-nav').outerHeight();
    let urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        scrollToAnker(urlHash);
      }, 100);
    }
    $('a.link-scroll').on('click', function(){
      let href= $(this).attr('href').replace(/.*#/, '');
      let hash = '#' + href;
      scrollToAnker(hash);
      return false;
    })
    function scrollToAnker(hash) {
      let target = $(hash);
      if(target.length){
        let position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 500);
        return false;
      }
    }
  })


  // MW WP FORM


  // エラーメッセージ
  if ( $('.mw_wp_form .error')[0] ) {
    $('.contact-hero').hide();
    const formEl = $('.mw_wp_form').eq(0);
    formEl.prepend('<p class="h5 text-center text-danger fw-bold mb-5">入力内容に誤りがあります</p>');
    const position = formEl.offset().top - 80;
    $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
  }

  // エラー位置にスクロール
  //if ( $('.mw_wp_form .error')[0] ) {
  //  const errorEl = $('.mw_wp_form .error').eq(0);
  //  const position = errorEl.parent().offset().top - 80;
  //  $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
  //}

  // 確認画面でスクロール
  if ($('.mw_wp_form.mw_wp_form_confirm')[0]){
    $('.contact-hero').hide();
    const position = $('.mw_wp_form.mw_wp_form_confirm').eq(0).offset().top - 80;
    $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
  }

  // 完了画面でスクロール
  if ($('.mw_wp_form.mw_wp_form_complete')[0]){
    $('.contact-hero').hide();
    const position = $('.mw_wp_form.mw_wp_form_complete').eq(0).offset().top - 80;
    $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
  }






  // WEB申し込み

  $(function() {
    $('.contract-type').on('change', function(){
      if ($('#inputContractType-1').is(':checked')) {
        $('.kojin').show();
        $('.hojin').hide();
      } else if($('#inputContractType-2').is(':checked')) {
        $('.kojin').hide();
        $('.hojin').show();
      }
      $('.change-form').find('textarea, :text, select').val('').end()
      .find(':checked').prop('checked', false);
    });
    if ($('#inputContractType-1').is(':checked')) {
      $('.kojin').show();
      $('.hojin').hide();
    } else if($('#inputContractType-2').is(':checked')) {
      $('.kojin').hide();
      $('.hojin').show();
    }
  });

  $(function() {
    const constractType = $('.mw_wp_form_confirm .select-contract-type input[name="ご契約形態"]').val();
    if(constractType === '個人'){
      $('.kojin').show();
      $('.hojin').hide();
    } else if(constractType === '法人'){
      $('.kojin').hide();
      $('.hojin').show();
    }
  });

})(jQuery);


